import React from 'react';
import Header from "./../../Components/Header";

const SearchProduct = () => {
    return (
        <>
        <Header/>
        <div className="section search_product">
            <div className="container">
                <div className="row">
                    
                </div>
            </div>
            
        </div>
    </>
    )
}

export default SearchProduct;
